import { CardFeesEnum } from '@Config/urls/cardManagementSystem.url';
import URLConfig from '@Config/urls/url.config';
import * as CardHolderModulePages from '@Modules/cardManagementSystem/cardholder/pages';
import { Navigate, Route } from 'react-router-dom';
import * as CustomerDetailPages from '@Modules/cardManagementSystem/cardholder/pages/cardData/customerDetail';
import * as AccountDetailPages from '@Modules/cardManagementSystem/cardholder/pages/cardData/accountDetail';
import { Fragment } from 'react';

const cardHolderRoutes: any[] = [
  // Parameters menu routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.PARAMETERS_MENU.ROOT}
    element={<CardHolderModulePages.CardHolderLayout />}
  >
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.PARAMETERS_MENU
          .REASON_CARD_REPLACEMENT
      }
      element={<CardHolderModulePages.ReasonCardReplacementPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.PARAMETERS_MENU
          .REASON_STOPPING_AUTOMATIC_CARD_RENEWAL
      }
      element={<CardHolderModulePages.ReasonStoppingAutomaticCardRenewalPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.PARAMETERS_MENU
          .REASON_CARD_STATUS
      }
      element={<CardHolderModulePages.ReasonCardStatusPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.PARAMETERS_MENU
          .REASON_CUSTOMER_STATUS
      }
      element={<CardHolderModulePages.ReasonCustomerStatusPage />}
    />
  </Route>,

  // Card Fees menu routes
  <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_FEES_MENU.ROOT} element={<CardHolderModulePages.CardFeesLayout />}>
    <Route path={`${URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_FEES_MENU.COMMON}:cardFeePage`} element={<CardHolderModulePages.CommonCardFeesPage />} />

    <Route path={`${URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_FEES_MENU.MISCELLANEOUS_FEE}`} element={<CardHolderModulePages.MiscellaneousFeesLayout />}>
      <Route path={":cardFeePage"} element={<CardHolderModulePages.CommonCardFeesPage />} />
      <Route index element={<Navigate to={CardFeesEnum.RECURRING_FEE} />} />
    </Route>

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_FEES_MENU.CARD_COMMISSION} element={<CardHolderModulePages.CardCommissionPage />} />
  </Route>,

  // Card Data menu routes
  <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.ROOT} element={<CardHolderModulePages.CardDataLayout />}>

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CARD_PRODUCT} element={<CardHolderModulePages.CardProductPage />} />

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CUSTOMER} element={<CardHolderModulePages.CustomerPage />} />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CUSTOMER_DETAIL + ':id/'
      }
      element={<CardHolderModulePages.CustomerDetailLayout />}
    >
      <Route path={'about'} element={<CustomerDetailPages.AboutPage />} />
      <Route path={'applicant'} element={<CustomerDetailPages.ApplicantPage />} />
      <Route
        path={'applicant-address'}
        element={<CustomerDetailPages.ApplicantAddressPage />}
      />
      <Route
        path={'correspondence-address'}
        element={<CustomerDetailPages.CorrespondenceAddressPage />}
      />
      <Route
        path={'languages'}
        element={<CustomerDetailPages.LanguagesPage />}
      />
      <Route
        path={'assets-and-income'}
        element={<CustomerDetailPages.AssetsAndIncomePage />}
      />
      <Route
        index
        path={'outstanding-debt'}
        element={<CustomerDetailPages.OutstandingDebtPage />}
      />
      <Route
        path={'required-documents'}
        element={<CustomerDetailPages.RequiredDocumentsPage />}
      />
      <Route
        path={'memo'}
        element={<CustomerDetailPages.MemoPage />}
      />
    </Route>

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.ACCOUNT} element={<CardHolderModulePages.AccountPage />} />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.ACCOUNT_DETAIL + ':id/'
      }
      element={<CardHolderModulePages.AccountDetailLayout />}
    >
      <Route path={'about'} element={<AccountDetailPages.AboutAccountPage />} />
      <Route path={'account-data'} element={<AccountDetailPages.AccountDataPage />} />
      <Route
        path={'revolving-data'}
        element={<AccountDetailPages.RevolvingDataPage />}
      />
      <Route
        path={'revolving-account-status'}
        element={<AccountDetailPages.RevolvingAccountStatusPage />}
      />
      <Route
        path={'credit-limit'}
        element={<AccountDetailPages.CreditLimitPage />}
      />
      <Route
        path={'risk-management'}
        element={<AccountDetailPages.OnlineRiskManagementPage />}
      />
      <Route
        index
        path={'prepaid-basic-parameters'}
        element={<AccountDetailPages.PrePaidBasicParametersPage />}
      />
      <Route
        path={'prepaid-reload-parameters'}
        element={<AccountDetailPages.PrePaidReloadParametersPage />}
      />
      <Route
        path={'insurance-fees'}
        element={<AccountDetailPages.InsuranceFeesPage />}
      />
      <Route
        path={'miscellaneous-periodic-fees'}
        element={<AccountDetailPages.MiscellaneousPeriodicFeesPage />}
      />
    </Route>

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CARD_DATA} element={<CardHolderModulePages.CardDataPage />} />

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CARD_CONSULTATION} element={<CardHolderModulePages.CardConsultationPage />} />

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CARD_STATUS_CONSULTATION} element={<CardHolderModulePages.CardStatusConsultationPage />} />

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CARD_STATUS_HISTORY} element={<CardHolderModulePages.CardStatusHistoryPage />} />

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.HISTORY_RESET_PIN_COUNTER} element={<CardHolderModulePages.HistoryResetPinCounterPage />} />

    <Route path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU['3D_SECURE_HISTORY']} element={<CardHolderModulePages.SecureHistory3DPage />} />

  </Route>,

  // Personalization Card  MENU ROUTES
  <Route>
    {cardPersonalizationMenuRoutes().map((oneRoute, index) => (
      <Fragment key={index}>{oneRoute}</Fragment>
    ))}  
  </Route>,
    // Card operations menu routes
    <Route
      path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU.ROOT}
      element={<CardHolderModulePages.CardHolderLayout />}
    >
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .CARD_RENEWAL
      }
      element={<CardHolderModulePages.CardRenewalPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .CARD_REPLACEMENT
      }
      element={<CardHolderModulePages.CardReplacementPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .PIN_RESET
      }
      element={<CardHolderModulePages.ResettingPINCounterPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .PIN_RECALCULATION_OPERATION
      }
      element={<CardHolderModulePages.PINRecalculationPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .RENEWAL_MODE_CHANGE
      }
      element={<CardHolderModulePages.ChangeRenewalModePage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .SERVICE_TRANSFER_ENROLLMENT
      }
      element={<CardHolderModulePages.TransferServiceMembershipPage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .CARD_STATUS_CHANGE
      }
      element={<CardHolderModulePages.CardStatusChangePage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .CUSTOMER_STATUS_CHANGE
      }
      element={<CardHolderModulePages.CustomerStatusChangePage />}
    />

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU
          .OPPOSITION
      }
      element={<CardHolderModulePages.OppositionPage />}
    />,
        <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU.OPPOSITION_DETAIL + ':id'
      }
      element={<CardHolderModulePages.OppositionDetailPage />}
    />
    
  </Route>,
];

function cardPersonalizationMenuRoutes() {
  const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_PERSONALIZATION_MENU;
  return [
    <Route
      path={URL.INCOMPLETE_PERSONALIZATION_CONSULTATION}
      element={<CardHolderModulePages.IncompletePersonalizationConsultationPage />}
    />,
    <Route
      path={URL.PRE_PERSONALIZATION_VALIDATION}
      element={<CardHolderModulePages.PrePersonalizationValidationPage />}
    />,
    <Route
      path={URL.SENDING_PERSONALIZATION_BATCH}
      element={<CardHolderModulePages.SendingPersonalizationBatchPage />}
    />,
    <Route
      path={URL.RETURN_PERSONALIZATION_BATCH}
      element={<CardHolderModulePages.ReturnPersonalizationBatchPage />}
    />,
  ];
}

export default cardHolderRoutes;
